export const checkPageLevel = (pathName) => {
    let page = 0
    let extractedPageLevel = pathName.split("/")
    let filteredPageLevel = extractedPageLevel.filter(item=>item)[0]

    if(filteredPageLevel === "/") {
          page = 0
    }
    else if(filteredPageLevel === "personal") {
      page = 0
    } else if (filteredPageLevel === "business"){
      page = 1
    } else if (filteredPageLevel === "explore-telecel"){
      page = 2
    }

    // console.log("page level::", page)	
    return page
}
export const phoneValidation = () => {
  let phoneNumberValidator =
    /^([+]|0)[(\s]{0,1}[5,2][0-9]{0,2}[\s-)]{0,2}[0-9][0-9][0-9\s-]*[0-9]$/;
  return phoneNumberValidator
}

export function downloadCSV(arrayOfObjects, fileName) {
  const csvContent = convertArrayOfObjectsToCSV(arrayOfObjects);
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  if (navigator.msSaveBlob) { // For IE 10 and above
    navigator.msSaveBlob(blob, fileName);
  } else {
    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', fileName);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}

function convertArrayOfObjectsToCSV(array) {
  const header = Object.keys(array[0]).join(',') + '\n';
  const rows = array.map(obj => Object.values(obj).join(',') + '\n');
  return header + rows.join('');
}



export const exportToCSV = (tableRef,filename) => {
  const table = tableRef.current;
  const csvRows = [];
  const rows = table.querySelectorAll("tr");

  rows.forEach(row => {
    const csvRow = [];
    row.querySelectorAll("td, th").forEach(cell => {
      csvRow.push(cell.innerText);
    });
    csvRows.push(csvRow.join(","));
  });

  const csvContent = csvRows.join("\n");
  const encodedUri = encodeURI("data:text/csv;charset=utf-8," + csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
};
